<header style="border-radius: 10px">
  <dx-toolbar class="header-toolbar">
    <!-- Menu Button -->
    <dxi-toolbar-item *ngIf="menuToggleEnabled" location="before">
      <button class="menu-button" (click)="toggleMenu()" style="background: none; border: none; cursor: pointer">
        <img src="assets/icons/togglemenu.png" alt="Toggle Menu" style="width: 24px; height: 24px" />
      </button>
    </dxi-toolbar-item>

    <!-- Logo -->
    <dxi-toolbar-item location="before" [cssClass]="'company-logo-item'">
      <ng-container *dxTemplate>
        <div class="custom-search-bar">
          <img src="assets/icons/headericon_pink.png" alt="Asha" style="width: 12rem; height: auto" />
        </div>
      </ng-container>
    </dxi-toolbar-item>

    // Button for developer only to refresh domain cache
    <dxi-toolbar-item *ngIf="LoginRole === Roles.Developer" >
      <button (click)="RefreshDomainCache()" style="background-color: rgb(230, 230, 230); color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer" [disabled]="isRefreshing">
        Refresh Domain Cache
      </button>
    </dxi-toolbar-item>

    <!-- Theme Switcher -->
    <dxi-toolbar-item location="after">
      <ng-container *dxTemplate>
        <theme-switcher></theme-switcher>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Notification + User -->
    <dxi-toolbar-item location="after">
      <ng-container *dxTemplate>
        <div class="user-section">
          <div class="bell-outline-wrapper" (click)="gotoNotification()" *ngIf="IsShowBtn">
            <i class="dx-icon dx-icon-bell"></i>
            <span class="notification-badge" *ngIf="notificationCount > 0">
              {{ notificationCount }}
            </span>
          </div>
          <app-user-panel [menuItems]="userMenuItems" [profileImage]="profileImageUrl"></app-user-panel>

          <div class="user-info">
            <div class="user-top-row">
              <span class="user-name">{{ UserDisplayName ? UserDisplayName : 'User' }}</span>
              <span class="user-role">{{ RoleName }}</span>
            </div>
            <div class="user-location" *ngIf="PHCName || SCName || VillageName">
              <div class="user-location-row1">
                <ng-container *ngIf="PHCName">
                  {{ langService.currentLang === 'mr' ? 'प्राथमिक आरोग्य केंद्र' : 'PHC' }} : {{ PHCName }}
                </ng-container>
                <ng-container *ngIf="SCName">
                  &nbsp;|&nbsp;{{ langService.currentLang === 'mr' ? 'उपकेंद्र' : 'SC' }} : {{ SCName }}
                </ng-container>
              </div>
              <div class="user-location-row2" *ngIf="VillageName">
                {{ langService.currentLang === 'mr' ? 'गाव' : 'Village' }} : {{ VillageName }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </dxi-toolbar-item>

    <div *dxTemplate="let item of 'menuItem'">
      <div class="menu-item">
        <img *ngIf="item.isProfile" [src]="profileImageUrl || 'assets/icons/imgpreview.png'" class="profile-image"
          alt="Profile" />
        <i *ngIf="!item.isProfile && item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
        <span class="menu-text">{{ item.text }}</span>
      </div>
    </div>

  </dx-toolbar>

  <!-- 👈 Breadcrumb OUTSIDE toolbar — below it -->
  <!-- <div class="breadcrumb-bar" *ngIf="breadcrumbs.length > 0">
    <ng-container *ngFor="let crumb of breadcrumbs; let last = last; let first = first">
      <span class="crumb" [class.clickable]="!last && !!crumb.path" [class.current]="last"
        (click)="!last && crumb.path ? navigateBreadcrumb(crumb.path) : null">
        <svg *ngIf="first" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" style="margin-top: -2px;">
          <path d="M3 9L12 2l9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        {{ crumb.label }}
      </span>
      <span class="separator" *ngIf="!last">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </span>
    </ng-container>
  </div> -->

  <div class="breadcrumb-bar" *ngIf="breadcrumbs.length > 0">
    <ng-container *ngFor="let crumb of breadcrumbs; let last = last; let first = first">
      <span class="crumb" [class.clickable]="!last && !!crumb.path" [class.current]="last"
        (click)="!last && crumb.path ? navigateBreadcrumb(crumb.path) : null">
        <span *ngIf="first" class="home-icon">🏠</span>
        {{ crumb.labelKey ? (crumb.labelKey | translate) : crumb.label }}
      </span>
      <span class="separator" *ngIf="!last"> › </span>
    </ng-container>
  </div>

</header>